import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://tvcarebangalore.in";
export const SITE_NAME = "TV CARE";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * SEO helper — outputs <title>, meta description, canonical, Open Graph,
 * Twitter Card, and any provided JSON-LD blocks.
 *
 * Usage:
 *   <Seo
 *     title="Sony TV Repair in Bangalore | TV CARE"
 *     description="Same-day doorstep Sony TV repair..."
 *     path="/sony-tv-repair-in-bangalore"
 *     jsonLd={[{ "@context": "https://schema.org", "@type": "Service", ... }]}
 *   />
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  jsonLd = [],
  noindex = false,
}) {
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
